/**
 * OCR API - On-premise document text extraction
 * @module api/ocr
 */

import { apiRequest } from './core.js';

export const ocrAPI = {
  /**
   * Extract text from a base64-encoded image
   * @param {string} base64Image - Base64 image data (with or without data URI prefix)
   * @param {string} hint - OCR hint for post-processing (e.g. "date", "nom", "VIN")
   * @returns {Promise<Object>} { ok: true, data: { text: "..." } }
   */
  extract: (base64Image, hint) =>
    apiRequest('/ocr/extract', {
      method: 'POST',
      body: JSON.stringify({ image: base64Image, hint }),
    }),
};
